/* eslint-disable no-console */
import { log, LogLevels } from '../api/logApi';

// Actions
// export const APP_ACTION_CONFIGURATOR_LOAD_FAILED = 'Carpet - Configurator Load Failed';
export const APP_ACTION_SAVE_AND_CONTINUE_FAILED = 'Carpet - Save And Continue Failed';
export const APP_ACTION_CREATE_CONFIGURATION_FAILED = 'Carpet - Create Configuration Failed';
export const APP_ACTION_LOAD_CONFIGURATION_FAILED = 'Carpet - Load Configuration Failed';
export const APP_ACTION_GRAPH_PRODUCT_CALL_FAILED = 'GraphQL - Product Data Error';
export const APP_ACTION_DESIGN_EMAIL_FAILED = 'Carpet - Design Email Failed';
export const APP_ACTION_CREATE_DESIGN_FAILED = 'Carpet - Create Design Failed';
export const APP_ACTION_GET_PADDING_FAILED = 'Carpet - Get Padding Failed';
export const APP_ACTION_GET_PADDING_NO_CONTENT = 'Carpet - Get Padding Failed'; // change this?
export const APP_ACTION_GET_PRICING_FAILED = 'Carpet - Get pricing Failed';
export const APP_ACTION_CARPER_PRICING_ISSUE = 'Carpet - Carpet has $0 Price';
export const APP_ACTION_GET_ESTIMATE_PRICING_FAILED = 'Carpet - Get estimate pricing Failed';
export const APP_ACTION_CARPET_PADDING_NO_MATCH = 'Carpet Padding no match';
// API
export const API_ENDPOINT_CREATE_CONFIGURATION = 'configurationApi';
export const API_ENDPOINT_GET_THD_PRICING = 'getThdPricing';

export const recordPageAction = (actionName, actionObject) => {
  try {
    if (window?.newrelic) {
      window.newrelic.addPageAction(actionName, actionObject);
    } else {
      log('Object newrelic not found.', LogLevels.Warn)
        .catch((error) => console.log('Error: ', error));
    }
  } catch (error) {
    log(`Error calling newrelic addPageAction with actionName = '${actionName}'`, LogLevels.Error)
      .catch(() => console.log('Error: ', error));
  }
};

export const logNewRelicError = (apiActionName, endPointName, status, url, payload) => {
  recordPageAction(apiActionName, {
    endPointName,
    status,
    url,
    ...payload,
  });
};